var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-tabbed-router',_vm._g({staticClass:"tabbed-router",attrs:{"tabs":_vm.localTabs,"position":_vm.position}},_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }